export const nudgeReasonReceivedToday = "Kbb";
export const nudgeReasonReceivedOneDayAgo = "Lbb";
export const nudgeReasonReceivedDaysAgo = "Mbb";
export const nudgeReasonSentToday = "Nbb";
export const nudgeReasonSentOneDayAgo = "Obb";
export const nudgeReasonSentDaysAgo = "Pbb";
export default {nudgeReasonReceivedToday,nudgeReasonReceivedOneDayAgo,nudgeReasonReceivedDaysAgo,nudgeReasonSentToday,nudgeReasonSentOneDayAgo,nudgeReasonSentDaysAgo};